import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { SubastasService } from '../_services';
import { element } from '@angular/core/src/render3';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-subastas',
  templateUrl: './subastas.component.html',
  styleUrls: ['./subastas.component.css']
})
export class SubastasComponent implements OnInit {
  public subastas: Array<object> = [];
  filtrarForm: FormGroup;
  categoriaList = [];
  marcaList = [];
  departamentoList = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownSettings2 = {};

  categoriasMarcadasList = [];
  marcasMarcadasList = [];
  departamentosMarcadosList = [];
  text: any = {
    Year: 'Años',
    Month: 'Meses',
    Weeks: 'Semanas',
    Days: 'd',
    Hours: 'h',
    Minutes: 'm',
    Seconds: 's',
    MilliSeconds: 'Milisegundos'
  };
  periodoActual: any;
  idPeriodoActual = null;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private subastasService: SubastasService
  ) { }

  ngOnInit() {
    this.filtrarForm = new FormGroup({
      campo: new FormControl(),
      valor: new FormControl()
    });
    this.getCategorias();
    this.getDepartamentos();
    // this.getSubastas();
    this.getPeriodoAbierto();

    this.marcaList = [
      { id: 0, descripcion: 'Marca líquida' },
      { id: 1, descripcion: 'Compra' }
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'descripcion',
      selectAllText: 'Todos',
      unSelectAllText: 'Desmarcar todos',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'Buscar'
    };

    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'id',
      textField: 'nombre',
      selectAllText: 'Todos',
      unSelectAllText: 'Desmarcar todos',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: 'Buscar'
    };
  }

  public getSubastas() {
    this.subastasService.getSubastas().subscribe((data: Array<object>) => {
      this.subastas = data;
    });
  }

  onSubmit() {
    this.getSubastasParametros();
  }

  public getDepartamentos() {
    this.subastasService.getDepartamentos().subscribe((data: Array<object>) => {
      this.departamentoList = data;
    });
  }

  public getCategorias() {
    this.subastasService.getCategorias().subscribe((data: Array<object>) => {
      this.categoriaList = data;
    });
  }

  onCategoriaSelect(item: any) {
    this.categoriasMarcadasList.push(item.id);
  }

  onCategoriaDeselect(item: any) {
    this.categoriasMarcadasList.splice(
      this.categoriasMarcadasList.indexOf(item.id),
      1
    );
  }

  onMarcaSelect(item: any) {
    this.marcasMarcadasList.push(item.id);
  }

  onMarcaDeselect(item: any) {
    this.marcasMarcadasList.splice(this.marcasMarcadasList.indexOf(item.id), 1);
  }

  onDepartamentoSelect(item: any) {
    this.departamentosMarcadosList.push(item.id);
  }

  onDepartamentoDeSelect(item: any) {
    this.departamentosMarcadosList.splice(
      this.departamentosMarcadosList.indexOf(item.id),
      1
    );
  }

  getSubastasParametros() {
    this.subastasService
      .getSubastasParametros(
        this.categoriasMarcadasList,
        this.marcasMarcadasList,
        this.departamentosMarcadosList,
        this.idPeriodoActual
      )
      .subscribe((data: Array<object>) => {
        this.subastas = data;
        this.subastas.map((s: any) => {
          s.imagenes.map(i => {
            i.url = environment.baseUrl + '/..' + i.url;
          });
          s.fechaInicioPuja = this.subastasService.fechaMysqlAfechaJs(
            s.fechaInicioPuja
          );
          s.fechaFinPuja = this.subastasService.fechaMysqlAfechaJs(
            s.fechaFinPuja
          );
        });
        this.subastasService.setUltimoResultado(data);
      });
  }

  onDepartamentoSelectAll(items) {
    this.departamentosMarcadosList = [];
    items.forEach(item => {
      this.departamentosMarcadosList.push(item.id);
    });
  }

  onMarcaSelectAll(items) {
    this.marcasMarcadasList = [];
    items.forEach(item => {
      this.marcasMarcadasList.push(item.id);
    });
  }

  onCategoriaSelectAll(items) {
    this.categoriasMarcadasList = [];
    items.forEach(item => {
      this.categoriasMarcadasList.push(item.id);
    });
  }

  public callback($event) {
    return;
  }

  getPeriodoAbierto() {
    this.subastasService.getUltimoPeriodo().subscribe((data: Array<object>) => {
      this.periodoActual = data[0];
      if (this.periodoActual !== undefined) {
        this.idPeriodoActual = this.periodoActual.id;
      }
      this.loading = true;
      this.getSubastasParametros();
    });
  }

  public separadorMiles(input) {
    const ret = input ? input.replace(/,/gi, '.') : null;
    return ret;
  }
}
